import * as t from "io-ts";
import * as util from "../../shared/src/util";

export const codec = t.union([
    t.literal("buyer"),
    t.literal("buyer_and_outsource"),
    t.literal("builder"),
    t.literal("not_renovating"),
    t.literal("unknown"),
]);

export type T = t.TypeOf<typeof codec>;

export const values = util.typeValuesFromCodec(codec.types as Array<t.LiteralC<T>>);
